import * as React from 'react';
import Icon from 'react-fa';
import classNames from 'classnames';
import { routes, LinkHelper } from '../routes';
import { hasRoute } from '../utils';

const styles = require('./mainLayout.less') as any;
//            (active_route.label.toLowerCase()===to.toLowerCase()) && styles.active
const NavIcon = ({ icon, active_routes, to, children=''}) => (
    <LinkHelper className={classNames(
            styles.NavIcon,
            hasRoute(active_routes, routes[to]) && styles.active && styles.active,
        )} to={to}>
        <Icon name={icon} />
        {children}
    </LinkHelper>
);

class NavBar extends React.Component< any,any> {
    render() {
      const { active_routes, isAuthenticated, profileCompleted=true, navPosition } = this.props;
        const classes = classNames(styles.NavBar, navPosition);
        return (
            <nav className={classes}>
                {!isAuthenticated && <NavIcon icon="rocket" to="login" active_routes={active_routes}>Login</NavIcon>}
                {isAuthenticated && <NavIcon icon="search" to="search" active_routes={active_routes}>Search</NavIcon>}
                {isAuthenticated &&
                 <NavIcon icon="user" to="profile" active_routes={active_routes}>Profile
                     {!profileCompleted && <Icon name="exclamation-circle" {...{title:'Complete your health Profile!'}}/>}
                 </NavIcon>}
                {isAuthenticated && <NavIcon icon="gear" to="account" active_routes={active_routes}>Settings</NavIcon>}
                {navPosition !== 'bottom' && <NavIcon icon="info-circle" to="about" active_routes={active_routes}>About</NavIcon>}
                <NavIcon icon="question" to="help" active_routes={active_routes}>Help</NavIcon>
            </nav>
        );
    }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/app/Layouts/NavBar.tsx